export default {
  "home.title": "Home",
  "home.subtitle": "Your laundry business summary for today",
  "home.today": "Today",
  "home.refresh": "Refresh",

  "home.cards.new": "New orders",
  "home.cards.newHint": "Awaiting the laundry's approval or rejection",
  "home.cards.inProgress": "Orders in progress",
  "home.cards.inProgressHint": "Only orders currently in progress",
  "home.cards.completedToday": "Completed today",
  "home.cards.completedHint": "By receipt confirmation",
  "home.cards.revenue": "Today's revenue",
  "home.cards.revenueHint": "Value of orders completed today before commission — the same as direct order revenue on the Finance page.",

  "home.newOrders.title": "New orders",
  "home.newOrders.subtitle": "Orders awaiting the laundry's decision",
  "home.newOrders.viewAll": "View new orders",
  "home.newOrders.empty": "No new orders awaiting approval",
  "home.newOrders.col.order": "Order no.",
  "home.newOrders.col.customer": "Customer",
  "home.newOrders.col.priority": "Priority",
  "home.newOrders.col.fulfillment": "Pickup & delivery",
  "home.newOrders.col.total": "Total amount",
  "home.newOrders.col.status": "Status",
  "home.newOrders.col.action": "Action",

  "home.escalation.title": "Orders needing manual action",
  "home.escalation.subtitle": "Orders in the delivery stage that need a driver assigned",
  "home.escalation.empty": "No orders need manual action",
  "home.escalation.badge": "Needs driver assignment",
  "home.escalation.reason": "The customer chose to wait and the grace period ended with no delivery task accepted",
  "home.escalation.viewOrder": "View order",
  "home.escalation.note": "The task stays available to drivers in parallel; a sub-driver can be assigned from the order details.",

  "home.summaryError": "Could not load the performance summary",
  "home.ordersError": "Could not load new orders",
  "home.escalationError": "Could not load alerts"
};